import { AxiosResponse } from 'axios';
import { translationResponseMiddleware } from '../middleware/translation-response';
import { decodeHtmlMiddleware } from '../middleware/decode-html';
import { promotionsCategoriesTranslationMiddleware } from '../middleware/promotions-categories-translation';
import { maintenanceTranslationMiddleware } from '../middleware/maintenance-translation'

const middlewares = [
  translationResponseMiddleware,
  promotionsCategoriesTranslationMiddleware,
  maintenanceTranslationMiddleware,
  decodeHtmlMiddleware,
];

/**
 * Processes an Axios response through a chain of middleware functions before passing the data to the components.
 * The middleware functions are applied sequentially using the `Array.prototype.reduce()` method.
 */
export const responseInterceptor = (response: AxiosResponse): AxiosResponse => middlewares.reduce((acc, middleware) => middleware(acc), response);
